import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { startWith } from 'rxjs/operators';

@Component({
  selector: 'search-templates',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {

  @Input() search: any;
  @Output() searchChange = new EventEmitter();

  constructor(
    private fb: FormBuilder,

  ) { }

  form: FormGroup;

  ngOnInit(): void {
    this.form = this.fb.group({
      studio: [this.search?.studio],
      nome: [this.search?.nome],
      compagnia: [this.search?.compagnia],
      tipo_template: [this.search?.tipo_template],
      stato_incarico: [this.search?.stato_incarico],
    });


    this.form.valueChanges.pipe(
      startWith(this.form.value)
    ).subscribe(v => this.searchChange.emit(v));


  }

  reset() {
    this.searchChange.emit({});
    this.form = null;

    setTimeout(
      () => this.ngOnInit(), 0
    )
  }

}
